module.exports = __webpack_public_path__ + "./img/token_awarded_medium.png";